module.exports = __webpack_public_path__ + "assets/img/NPC004.a4aeaf5e.png";